import React from "react";
import Icon from "./Icon";

const ListSelect = ({
  heading,
  defaultOption,
  options,
  showOptions,
  onClickShow,
  onClickOption,
  selectedOptions,
  isSelectAll,
  onClickSelectAll,
  singleSelect,
}) => {
  const mainContainer = {
    backgroundColor: "#F5F5F5",
    borderBottom: "2px solid #003E85",
  };
  const selectContainer = {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    paddingRight: "10px",
    cursor: "pointer",
  };
  const viewContainer = {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "16px",
    paddingTop: "2px",
    height: "44px",
    flex: 1,
  };
  const headingText = {
    fontFamily: "Roboto-Regular",
    fontSize: "12px",
    color: "#515353",
  };
  const optionText = {
    fontFamily: "Roboto-Regular",
    fontSize: "14px",
    color: "#060808",
    display: "flex",
    flex: 1,
    overflow: "clip",
  };
  const optionContainer = {
    display: "flex",
    flexDirection: "row",
    paddingLeft: "16px",
    paddingRight: "10px",
    borderTop: "1px solid #C8C8C8",
    alignItems: "center",
    paddingTop: "13px",
    paddingBottom: "13px",
    cursor: "pointer",
  };
  return (
    <div style={mainContainer}>
      <div style={selectContainer} onClick={onClickShow}>
        <div style={viewContainer}>
          <text style={headingText}>{heading}</text>
          <text style={optionText}>{defaultOption}</text>
        </div>
        <Icon icon="downIcon" />
      </div>
      {showOptions && (
        <div
          style={{
            maxHeight: "181px",
            overflow: "auto",
          }}
        >
          {options?.length && !singleSelect ? (
            <div style={optionContainer} onClick={onClickSelectAll}>
              <text style={optionText}>{"Select All"}</text>
              {isSelectAll && <Icon icon="selectCheck" />}
            </div>
          ) : null}
          {options?.map &&
            options?.map((option) => (
              <div
                style={optionContainer}
                key={option?.value}
                onClick={() => onClickOption(option)}
              >
                <text style={optionText}>{option?.label}</text>
                {selectedOptions.some((e) => e.value === option?.value) && (
                  <Icon icon="selectCheck" />
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default ListSelect;
